<div class="row">
  <div class="col-1 text-align-center margin-auto no-padding-xs pl-xs-15">
    <div class="suggestion-dot" [style.background-color]="color"></div>
  </div>
  <div class="col-2 text-align-center margin-auto no-padding-xs font-size-smaller1 font-size-sm-base">
    <span class="suggestion-percentage">{{ suggestionPercentage }}%</span>
  </div>
  <div class="col-7 text-start text-align-left margin-auto no-padding-xs font-size-smaller1 font-size-sm-base">
    <web-components-instrument-details-link [isin]="suggestion.isin">
      {{ suggestion.name }}
    </web-components-instrument-details-link>
  </div>
  <div class="col-2 d-flex justify-content-end no-padding-xs pr-xs-15">
    <div
      class="trade savings-plan cursor-pointer"
      [title]="'savings-plan.most-chosen.item.title' | transloco"
      [routerLink]="savingPlanMaskUrl + '/' + suggestion.isin"
    >
      <svg class="icon icon-24">
        <use xlink:href="/assets/img/svgs/svgset.svg#pig" />
      </svg>
    </div>
  </div>
</div>
@if (suggestion.amount !== 100) {
  <hr class="less-margin" />
}
